// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"e306c4ca","308":"bd4a8974"}[chunkId] + ".chunk.js";
};